import React, { useState, useCallback, useEffect } from "react";
import { Box, useMediaQuery, IconButton } from "@mui/material";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import useEmblaCarousel from 'embla-carousel-react';
import Autoplay from 'embla-carousel-autoplay';

const Banner = ({ items }) => {
  const isMobile = useMediaQuery("(max-width:768px)");
  const [selectedIndex, setSelectedIndex] = useState(0);

  const [emblaRef, emblaApi] = useEmblaCarousel(
    { 
      loop: true, 
      duration: 0, // Movimiento del slide 40 default
      watchDrag: false // Arrastre manual con el dedo
    }, 
    [Autoplay({ delay: 6000, stopOnInteraction: false, stopOnMouseEnter: true })]
  );

  const onSelect = useCallback(() => {
    if (!emblaApi) return;
    setSelectedIndex(emblaApi.selectedScrollSnap());
  }, [emblaApi]);

  useEffect(() => {
    if (!emblaApi) return;
    emblaApi.on("select", onSelect);
    emblaApi.on("reInit", onSelect);
  }, [emblaApi, onSelect]);

  const arrowStyle = {
    position: 'absolute',
    top: '50%',
    transform: 'translateY(-50%)',
    zIndex: 10,
    bgcolor: 'rgba(29, 28, 28, 0.33)',
    backdropFilter: 'blur(4px)',
    color: 'white',
    '&:hover': { bgcolor: 'rgba(255, 255, 255, 0.4)' },
  };

  return (
    <Box sx={{ 
      position: 'relative', 
      width: '100%', 
      mt: "75px", 
      overflow: 'hidden',
      height: { xs: '100%' } 
    }}>
      
      <IconButton onClick={() => emblaApi?.scrollPrev()} sx={{ ...arrowStyle, left: isMobile ? 10 : 30 }}>
        <ArrowBackIosNewIcon fontSize={isMobile ? "small" : "large"} />
      </IconButton>

      <IconButton onClick={() => emblaApi?.scrollNext()} sx={{ ...arrowStyle, right: isMobile ? 10 : 30 }}>
        <ArrowForwardIosIcon fontSize={isMobile ? "small" : "large"} />
      </IconButton>

      <Box ref={emblaRef} sx={{ height: '100%', width: '100%' }}>
        <Box sx={{ 
          display: 'flex', 
          height: '100%',
          marginLeft: 0 
        }}>
          {items.map((item, index) => (
            <Box 
              key={item.id || index} 
              sx={{ 
                flex: '0 0 100%',
                minWidth: 0,
                position: 'relative',
                marginLeft: index === 0 ? 0 : '-100%', 
                zIndex: selectedIndex === index ? 2 : 1,
                opacity: selectedIndex === index ? 1 : 0,
                transition: 'opacity 1.2s ease-in-out',
                pointerEvents: selectedIndex === index ? 'auto' : 'none',
              }}
            >
              <Box
                component="img"
                src={isMobile ? item.mobileImg : item.desktopImg}
                alt={`Banner ${index + 1}`}
                loading={index === 0 ? "eager" : "lazy"}
                sx={{
                  width: '100%',
                  height: '100%',
                  display: 'block',
                  objectFit: 'cover',
                }}
              />
            </Box>
          ))}
        </Box>
      </Box>

      {/* Indicadores (Dots) */}
      <Box sx={{ 
        position: 'absolute', 
        bottom: 30, 
        left: '50%', 
        transform: 'translateX(-50%)', 
        display: 'flex', 
        gap: 1.5, 
        zIndex: 10 
      }}>
        {items.map((_, index) => (
          <Box
            key={index}
            onClick={() => emblaApi?.scrollTo(index)}
            sx={{
              width: selectedIndex === index ? 40 : 12,
              height: 12,
              borderRadius: 6,
              bgcolor: selectedIndex === index ? 'white' : 'rgba(255,255,255,0.4)',
              cursor: 'pointer',
              transition: 'all 0.4s ease',
              boxShadow: '0px 3px 6px rgba(0,0,0,0.3)',
            }}
          />
        ))}
      </Box>
    </Box>
  );
};

export default Banner;